import _ from 'lodash'

import { DateTime } from 'luxon'

import Big from 'big.js'

Big.RM = Big.roundHalfUp;

const moment  = window.moment;

moment.locale('fr');

const numeral = window.numeral;

numeral.locale('en');

let app = window.app;

/**
 * Deep merge two objects.
 * @param target
 * @param ...sources
 **/
export function mergeDeep (target, ...sources)
{
	if (!sources.length) return target;

	const source = sources.shift();

	if (isObject(target) && isObject(source))
	{
		for (const key in source)
		{
			if (isObject(source[key]))
			{
				if (!target[key]) Object.assign(target, { [key]: {} });
				{
					mergeDeep(target[key], source[key]);
				}
			}
			else
			{
				Object.assign(target, { [key]: source[key] });
			}
		}
	}

	return mergeDeep(target, ...sources);

/**
 * Simple object check.
 * @param item
 * @returns {boolean}
 **/
	function isObject (item)
	{
		return (item && typeof item === 'object' && !Array.isArray(item));
	}
}

export function moneyRound (amount)
{
	return (Math.round(amount*Math.pow(10,2))/Math.pow(10,2)).toFixed(2);
}

export function centsFromPrice (price)
{
	let value = String(price).split(',').join('.').split('.');

	let cents;

	if (value[1])
	{
		cents = value[1];
	}
	else
	{
		cents = '00';
	}

	if (cents.length === 1)
	{
		cents += '0';
	}
	else if (cents.length === 0)
	{
		cents = '00';
	}

	return value[0] + cents;
}

export function search (string, searched)
{
	let searched_words = (searched || '').trim().split(' ');
	let words          = (string || '').trim().split(' ');

	let matches = 0;

	searched_words.forEach(function (searched_word)
	{
		words.forEach(function (word)
		{
			if (simplify(word).includes(simplify(searched_word)))
			{
				matches++;
			}
		});
	});

	return matches;

	function simplify (word)
	{
		if (word.normalize instanceof Function)
		{
			return word.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
		}
		else
		{
			return word.toLowerCase();
		}
	}
}

export function stripSpecialChar (string)
{
	if (string.normalize instanceof Function)
	{
		return string.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
	}
	else
	{
		return string.toLowerCase();
	}
}

export function priceFromCents (value)
{
	var price = String(value);

	while (price.length < 3)
	{
		price = '0' + price;
	}

	price = price.slice(0, price.length-2) + '.' + price.slice(price.length-2);

	if (price.indexOf('.00') !== -1)
	{
		price = price.substring(0, price.length-3);
	}

	return price;
}

export function capitalize (value)
{
	let string = String(value || '');

	if (!string[0]) return '';

	string = string[0].toUpperCase() + string.slice(1).toLowerCase();

	return string;
}

export function getPlaceLabel (place_data)
{
	let place_label = [];

	let is_line_2_first = false;

	if (typeof place_data.address.line_2 === 'string')
	{
		let line_2 = place_data.address.line_2;

		is_line_2_first = ['Zone', 'ZI', 'ZA', 'Espace']
		.find(function (str)
		{
			return line_2.toLowerCase().indexOf(str.toLowerCase()) !== -1;
		});
	}

	if (place_data.name && place_data.name !== place_data.address.line_1 &&
		place_data.name !== place_data.address.line_2 )
	{
		place_label.push(place_data.name);
	}

	if (is_line_2_first && place_data.address.line_2)
	{
		place_label.push(place_data.address.line_2);
	}

	if (place_data.address.line_1)
	{
		place_label.push(place_data.address.line_1);
	}

	if (!is_line_2_first && place_data.address.line_2)
	{
		place_label.push(place_data.address.line_2);
	}

	if (place_data.address.zip_code)
	{
		place_label.push(place_data.address.zip_code);
	}

	if (place_data.address.city)
	{
		if (place_data.address.zip_code)
		{
			place_label[place_label.length-1] += ' ' + place_data.address.city;
		}
		else
		{
			place_label.push(place_data.address.city);
		}
	}

	if (place_label.length > 1)
	{
		place_label = place_label.join(', ');
	}
	else if (place_label.length === 1 && place_label[0])
	{
		place_label = place_label[0];
	}
	else
	{
		place_label = '';
	}

	return place_label;
}

export function getCartAbondement ()
{
	if (app.state.session.permissions.title === 'EC') return 0;

	let cart = _.cloneDeep(app.state.cart);

	let products_total = numeral(0);

// get total products price
	cart.forEach(function (item)
	{
		let price = numeral(safeNumeral(item.cart_price.price));

		price.multiply(item.cart_qty);

		products_total.add(price.value());
	});

	let total = numeral(0);

	let grouped_by_id = [], cart_abondements = [];

	cart.filter(product => product._abondement ? true : false)
	.forEach(function (product)
	{
		let grouped = grouped_by_id.find(data => data.id === product.id);

		let abondement = cart_abondements
		.find(abondement => abondement.data.id === product._abondement.data.id);

		if (typeof grouped !== 'undefined')
		{
			let new_qty = numeral(grouped.cart_qty);

			new_qty.add(product.cart_qty);

			grouped.cart_qty = new_qty.value();
		}
		else
		{
			grouped_by_id.push(product);
		}

		if (typeof abondement === 'undefined')
		{
			cart_abondements.push(_.cloneDeep(product._abondement));
		}
	});

	grouped_by_id
	.forEach(function (product)
	{
		const EC_abondement = app.state.session.EC.abondement.value;

		let abondement = cart_abondements
		.find(abondement => abondement.data.id === product._abondement.data.id);

	// Qty already used by the user
		const already_used = numeral(safeNumeral(abondement.used));

	// Maximum allowed qty per user
		let qty_per_user = numeral(safeNumeral(abondement.data.qty));

	// Maximum allowed per user reached
		if (already_used.value() >= qty_per_user.value()) return;

	// Qty remaining for this product
		let qty_left = qty_per_user.clone().subtract(already_used.value());

	// Prevent to exceed the maximum per user allowed
		if (qty_left.value() > product.cart_qty)
		{
			qty_left = numeral(product.cart_qty);
		}

	// Abondement amount
		let amount = numeral
		(
			safeNumeral(abondement.data.value)
		);

		amount.multiply(qty_left.value());

		already_used.add(qty_left.value());

	// Cancel each qty above EC's available money
		while (EC_abondement < total.value() + amount.value())
		{
			amount.subtract(safeNumeral(abondement.data.value));

			already_used.subtract(qty_left.value());
		}

		products_total.subtract(amount.value());

		abondement.used = already_used.value();

	// Prevent adding abondement if abondement > cart price
		if (products_total.value() > 0)
		{
			total.add(amount.value());
		}
	});

	return total.value();
}

export function getCartTotal (props)
{
	let total = numeral(0), returned_infos = { };

	if (!props) props = { };

	app.state.cart.forEach(function (item)
	{
		let item_cost = numeral(safeNumeral(item.cart_price.price)).divide(100);

		item_cost.multiply(item.cart_qty);

		total.add(item_cost.value());
	});

	returned_infos.cart_cost = total.value();

	let shipping_method = app.state.order_process.shipping['shipping[method]'] || '';

	let shipping_price = ((app.state.session.EC || { })
		.config || { })['shipping_' + shipping_method + '_price'] || 0;

	if (props.no_shipping !== true)
	{
		let price = numeral(safeNumeral(shipping_price));

		total.add(price.value());

		returned_infos.shipping_cost = price.value();
	}

	let product_abondement = getCartAbondement();

	if (product_abondement > 0)
	{
		total.subtract(product_abondement);

		returned_infos.product_abondement = product_abondement;
	}

	let user_abondement = app.state.order_process.user_abondement || 0;

	if (props.no_user_abondement !== true)
	{
		total.subtract(user_abondement);

		returned_infos.user_abondement = user_abondement;
	}

	returned_infos.total = total.value();

	return returned_infos;
}

export function isProductAbondable (product, abondement, user_abondement)
{
	if (!user_abondement)
	{
		user_abondement = app.state.session.user_abondement;
	}

	if (!abondement) return false;

	if (!user_abondement) return true;

	let qty_allowed = numeral(abondement.qty);

	let recurrence = abondement.recurrence || 'unique';

	user_abondement.catalog_used.filter(function (data)
	{
		return data.product === product.id;
	})
	.filter(function (data)
	{
		return moment(data.date).isSame(moment(), recurrence);
	})
	.forEach(function (data)
	{
		qty_allowed.subtract(data.qty);
	});

	return qty_allowed.value() > 0;
}

export function isTrue (value)
{
	return [true, 'true'].includes(value);
}

export function isFalse (value)
{
	return [false, 'false'].includes(value);
}

const allowed_values =
[
	'0', '1', '2', '3', '4', '5', '6', '7', '8', '9'
];

export function cleanNumber ({ number='', positive, int, digits, max })
{
	if (typeof number === 'number')
	{
		number = String(number);
	}
	else if (typeof number !== 'string')
	{
		return '0';
	}

	const allowed = allowed_values.slice(0);

	if (!positive) allowed.push('-');

	if (!int)
	{
		allowed.push(',');
		allowed.push('.');
	}

	const value = Array.from(number || '')
	.filter(letter => allowed.includes(letter))
	.join('')
	.split(',')
	.join('.')
	.split('.');

	let safe_value = value[0] || '';

	if (value.length > 1)
	{
		const digits_str = value[1] + value.slice(2).join('');

		safe_value += '.' + (digits
		? digits_str.slice(0, parseInt(digits))
		: digits_str);
	}

	if (safe_value === '.')
	{
		safe_value = '0.';
	}

	if (safe_value && Array.from(safe_value).every(char => char === '0'))
	{
		return '0';
	}

	if (max)
	{
		const val = safeNumeral(safe_value);

		if (numeral(val).value() > max) return max;
	}

	return safe_value;
}

export function safeNumeral (value='')
{
	if (typeof value === 'number') value = String(value);

	let safe_value = cleanNumber({ number: value });

	if (safe_value.startsWith('.'))
	{
		safe_value = '0' + safe_value;
	}

	if (safe_value.endsWith('.'))
	{
		safe_value = safe_value.slice(0, safe_value.length-1);
	}

	if (value && isNaN(parseFloat(safe_value)))
	{
		console.log('NaN', safe_value);

		return '0';
	}

	return safe_value || '0';
}

export function formatNum (number, format='0,0[.]00')
{
	return numeral(safeNumeral(number))
	.format(format)
	.split(',')
	.join(' ');
}

/**
 * @version 2.0.0
 *
 * @param { string|number } value entrée
 * @param { [number] } digits nombre de chiffres après la virgule
 *
 * @returns { number } nombre arrondi
**/
export function num (value, digits=2)
{
	const as_number = getAsNumber(value);

	if (!as_number) return 0;

	if (Number.isInteger(as_number)) return as_number;

	const big_number = new Big(as_number);

	return Number(big_number.round(digits));
}

const numbers_list =
[
	'0', '1', '2', '3', '4', '5', '6', '7', '8', '9'
];

/**
 * @version 2.0.0
 *
 * @param { any } entrée
 *
 * @returns { number } nombre correspondant à l'entrée, 0 si null ou non traitable
**/
export function getAsNumber (str='')
{
	if (typeof str === 'number') return str;
	if (typeof str === 'undefined' || !str) return 0;
	if (typeof str !== 'string') return 0;

	const safe_str = Array.from(str.split(',').join('.'))
	.filter(char => char === '.' || numbers_list.includes(char))
	.reduce(function (num, char)
	{
		if (num.includes('.') && char === '.') return num; // une seule virgule

		return num + char;
	},
	'');

	return Number((str.startsWith('-') ? '-' : '') + safe_str);
}

export function getShippingMethodLabel (method='')
{
	return method === 'home'
	? 'À domicile'
	: method === 'synergies'
	? 'Retrait Synergies'
	: method === 'EC'
	? 'En CE'
	: 'Électronique';
}

export function getOnlineType (value)
{
	const options =
	[
		{
			value: 'instant',
			label: 'E-billet instantané'
		},
		{
			value: '24_48',
			label: 'E-billet 24/48h'
		},
		{
			value: '48_72',
			label: 'Courrier 48h/72h'
		}
	];

	const match = options.find(opt => opt.value === value);

	return match ? match.label : undefined;
}

export function getRenewalYear (date)
{
	const NOW = date ? DateTime.fromISO(date) : DateTime.now();

	const year_threshold = NOW.startOf('year').plus({ months: 12 });

	const RENEWAL_YEAR = NOW > year_threshold
	? NOW.toFormat('yyyy')
	: NOW.startOf('year').minus({ days: 7 }).toFormat('yyyy');

	return RENEWAL_YEAR;
}